import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import type { CHIP_COLOR } from '@ebm-papst/ep-web-components';
import { ClientRequest, ClientRequestStatus } from '../../services/keycloak-admin-api';

const STATUS_CHIP: Record<ClientRequestStatus, { color: `${CHIP_COLOR}`; label: string }> = {
  PENDING: { color: 'warning', label: 'Pending' },
  APPROVING: { color: 'warning', label: 'Pending' },
  APPROVED: { color: 'friendly', label: 'Approved' },
  DENIED: { color: 'danger', label: 'Denied' },
};

@Component({
  selector: 'app-client-request-card',
  imports: [DatePipe, RouterLink],
  templateUrl: './client-request-card.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientRequestCard {
  readonly request = input.required<ClientRequest>();
  readonly showRequester = input(false);
  // Admins see the internal APPROVING state; requesters see it as pending
  readonly adminView = input(false);

  protected readonly statusChip = computed(() =>
    this.adminView() && this.request().status === 'APPROVING'
      ? { color: 'warning' as const, label: 'Approval in progress' }
      : STATUS_CHIP[this.request().status]
  );
  protected readonly showReview = computed(
    () => !!this.request().reviewedAt && this.request().status !== 'APPROVING'
  );
  protected readonly displayedClientId = computed(
    () => this.request().finalClientId ?? this.request().requestedClientId
  );
  protected readonly showDenyReason = computed(
    () => this.request().status === 'DENIED' && !!this.request().denyReason
  );
  protected readonly showOpenClient = computed(
    () => this.request().status === 'APPROVED' && !!this.request().finalClientId
  );
}
